import {Dialog} from 'primereact/dialog'
import {forwardRef, useImperativeHandle, useMemo, useState} from 'react'
import {useParams} from 'react-router-dom/cjs/react-router-dom.min'
import TranslateUtils from '../../i18n/TranslateUtils'
import {
    blockOverflownScroll,
    unblockOverflownScroll,
} from '../../utils/BlockScrollsUtils'
import {useAuth} from '../authentication/AuthProvider'
import LatestTrendChart from './LatestTrendChart'
import {summaryDataList} from './SummaryConstant'

import {Button} from 'primereact/button'
import {ReactComponent as BsEmojiDizzyFill} from '../../assets/icons/BsFillEmojiDizzyFill.svg'
import {useUserSummary} from './query-keys/SummaryKeysManager'
const SummaryTable = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        showForm: handleShowForm,
        hideForm: handleHideForm,
    }))

    //#region ID
    const {id: idString} = useParams()
    const id = useMemo(() => {
        return !!idString ? parseInt(idString) : null
    }, [idString])
    //#endregion

    //#region Context
    const {user} = useAuth()
    //#endregion

    //#region Translate
    const {translateCommons, translateDatatable} = TranslateUtils()
    //#endregion

    //#region State
    const [visible, setVisible] = useState(false)
    //#endregion

    //#region Query
    const {data: summaryData, refetch: refectSummary} = useUserSummary(
        user?.id,
        id,
        !!user?.id && !!id && !!visible,
    )
    //#endregion

    //#region Handle Function
    const handleShowForm = () => {
        blockOverflownScroll()
        setVisible(true)
    }

    const handleHideForm = () => {
        unblockOverflownScroll()
        setVisible(false)
    }
    //#endregion

    //#region Effect
    // useEffect(() => {
    //     if (!!user?.id && !!id) {
    //         refetchEvent.on('REFETCH-DATA-TABLE-Summary' + id, () => {
    //             refectSummary()
    //         })

    //         return () => {
    //             refetchEvent.removeListener('REFETCH-DATA-TABLE-Summary' + id)
    //         }
    //     }
    // }, [id, refectSummary, user])
    //#endregion

    return (
        <Dialog
            header={translateCommons('Summary')}
            breakpoints={{'1550px': '80vw', '1080px': '100vw'}}
            style={{
                width: '60vw',
            }}
            visible={visible}
            onHide={handleHideForm}>
            <div className="w-full bg-white">
                <div className="col-12">
                    <h4 className="font-semibold flex align-items-center">
                        {summaryData && summaryData?.recordedAt
                            ? `${translateCommons('Recorded at')} ${
                                  summaryData?.recordedAt
                              }`
                            : ''}
                    </h4>
                    <p className="font-semibold">
                        {translateCommons(
                            "Summary tables can consolidate patient's health index results. This allows quick access to critical information during patient encounters, aiding in informed decision-making and improving patient safety.",
                        )}
                    </p>
                    <hr />
                </div>
                <div className="col-12 border-round-2xl bg-blue-50 border-round-xl">
                    <div className="flex flex-wrap justify-content-center">
                        {summaryDataList?.map((summary, idx) => (
                            <div
                                key={idx}
                                className="grid align-items-stretch col-12 md:col-4 lg:col-4 sm:col-6">
                                <div className=" bg-white border-round w-full">
                                    {/* Label & Icon */}

                                    <div className="grid col-12 align-items-start h-full">
                                        {/* Text */}
                                        <div
                                            className={`${
                                                summary?.key !==
                                                'levelOfConsciousness'
                                                    ? 'col-12 md:col-5 lg:col-4'
                                                    : 'col-12'
                                            }`}>
                                            {summary?.key !==
                                                'levelOfConsciousness' && (
                                                <div className="w-full p-2">
                                                    <div className="flex align-items-center w-full">
                                                        <div className="mr-2">
                                                            {summary?.icon}
                                                        </div>
                                                        <p>
                                                            {translateCommons(
                                                                summary?.label,
                                                            )}
                                                        </p>
                                                    </div>
                                                </div>
                                            )}
                                            {/* Stat */}
                                            <div className="w-full">
                                                {summaryData ? (
                                                    summary?.key ===
                                                    'levelOfConsciousness' ? (
                                                        <div className="grid col-12 p-0">
                                                            <div className="flex flex-column justify-content-between col-12 lg:col-6 border-none lg:border-right-1 p-0">
                                                                <div className="w-full p-2">
                                                                    <div className="flex align-items-center justify-content-center w-full">
                                                                        <div className="mr-2">
                                                                            {
                                                                                summary?.icon
                                                                            }
                                                                        </div>
                                                                        <p className="">
                                                                            {translateCommons(
                                                                                summary?.label,
                                                                            )}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <h4
                                                                    className={`mb-0 text-center font-bold`}>
                                                                    {translateDatatable(
                                                                        summaryData[
                                                                            'levelOfConsciousnessValue'
                                                                        ],
                                                                    )}
                                                                </h4>
                                                            </div>
                                                            <div className="flex flex-column justify-content-between col-12 lg:col-6 p-0">
                                                                <div className="w-full p-2">
                                                                    <div className="flex align-items-center justify-content-center w-full">
                                                                        <div className="mr-2">
                                                                            <BsEmojiDizzyFill
                                                                                style={{
                                                                                    height: '24px',
                                                                                    width: '24px',
                                                                                    color: '#D10363',
                                                                                }}
                                                                            />
                                                                        </div>
                                                                        <p>
                                                                            {translateCommons(
                                                                                'Confusion',
                                                                            )}
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                                {!!summaryData[
                                                                    'confusion'
                                                                ] ? (
                                                                    <h4
                                                                        className={`mb-0 text-center font-bold`}
                                                                        style={{
                                                                            color: 'red',
                                                                        }}>
                                                                        {translateCommons(
                                                                            'Yes',
                                                                        )}
                                                                    </h4>
                                                                ) : (
                                                                    <h4
                                                                        className={`mb-0 text-center font-bold`}
                                                                        style={{
                                                                            color: 'green',
                                                                        }}>
                                                                        {translateCommons(
                                                                            'No',
                                                                        )}
                                                                    </h4>
                                                                )}
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <h1
                                                            className={`mb-0 font-bold`}>
                                                            {((!!summaryData[
                                                                summary?.key
                                                            ] ||
                                                                summaryData[
                                                                    summary?.key
                                                                ] === 0) &&
                                                                `${
                                                                    summaryData[
                                                                        summary
                                                                            ?.key
                                                                    ]
                                                                }`) ||
                                                                '-'}
                                                            {summary?.unit &&
                                                            (!!summaryData[
                                                                summary?.key
                                                            ] ||
                                                                summaryData[
                                                                    summary?.key
                                                                ] === 0) ? (
                                                                <span
                                                                    style={{
                                                                        fontSize:
                                                                            '1.4rem',
                                                                    }}>
                                                                    {` `}
                                                                    {
                                                                        summary.unit
                                                                    }
                                                                </span>
                                                            ) : (
                                                                ''
                                                            )}
                                                        </h1>
                                                    )
                                                ) : (
                                                    <h1 className={`mb-0 `}>
                                                        -
                                                    </h1>
                                                )}
                                            </div>
                                        </div>
                                        {/* Chart */}
                                        {summary.key !==
                                            'levelOfConsciousness' && (
                                            <div className="col-12 md:col-7 lg:col-8">
                                                {!!summary?.isChart
                                                    ? summaryData?.dataPoint &&
                                                      !!summaryData?.dataPoint[
                                                          summary?.key
                                                      ] &&
                                                      summaryData?.dataPoint[
                                                          summary?.key
                                                      ]?.length > 0 && (
                                                          <LatestTrendChart
                                                              summary={summary}
                                                              dataPoint={
                                                                  summaryData
                                                                      ?.dataPoint[
                                                                      summary
                                                                          ?.key
                                                                  ] || []
                                                              }
                                                          />
                                                      )
                                                    : ''}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="mt-3 col-12">
                    <Button
                        className="col-12 p-button-lg p-button-outlined"
                        label={translateCommons('CLOSE')}
                        icon="pi pi-times"
                        onClick={handleHideForm}
                    />
                </div>
            </div>
        </Dialog>
    )
})

export default SummaryTable
